import { Navigate, useLocation } from "react-router-dom";
interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute = ({children } : ProtectedRouteProps) => {
    const token = JSON.parse(localStorage.getItem('token') || 'null');
	const location = useLocation();
    return token ? children : <Navigate to={'/'} state={{from: location}} />
};

export default ProtectedRoute;